<template>
  <div class="qty">
    <a href="#" @click.prevent="minus">
      －
    </a>
    <span class="qty-num">{{ qty }}</span>
    <a href="#" @click.prevent="add">
      +
    </a>
  </div>
</template>


<script>
export default {
  props: {
    row: String,
    selectQty: Number
  },

  data() {
    return {
      qty: 1,
      options: {
        searchable: false
      }
    };
  },

  mounted() {
    this.qty = this.selectQty;
  },

  methods: {
    add() {
      this.qty++;
      this.updateCart();
    },

    minus() {
      if (this.qty > 1) {
        this.qty--;
      }

      this.updateCart();
    },
    updateCart() {
      let url = `/carts/${this.row}/update`;

      let params = {
        qty: this.qty
      };

      axios.patch(url, params).then(r => {
        eventHub.$emit("updateCart");
      });
    }
  }
};
</script>
